import Form from '../common/form';
import PropTypes from 'prop-types';
import Joi from 'joi';

import * as dummyData from '../../utils/data';
import * as models from '../../utils/models';

class HelideckSummaryForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		dryMethodResult: Joi.string().required().label('Dry Method'),
		wetMethodResult: Joi.string().required().label('Wet Method'),
		general: Joi.string().min(30).required().label('General Finding'),
		remarks: Joi.string().min(30).required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderSelect({
							name: 'dryMethodResult',
							label: 'Dry Method',
							placeholder: 'Select Dry Method Result',
							options: dummyData.getHelideckResultOptions(),
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'wetMethodResult',
							label: 'Wet Method',
							placeholder: 'Select Wet Method Result',
							options: dummyData.getHelideckResultOptions(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'general',
							label: 'General Finding',
							rows: '6',
							placeholder: 'Enter at least 30 characters',
						})}
					</div>

					<div className="col">
						{this.renderTextArea({
							name: 'remarks',
							label: 'Remarks',
							rows: '6',
							placeholder: 'Enter at least 30 characters',
						})}
					</div>
				</div>

				{this.renderButton('Proceed')}
			</form>
		);
	}
}

export default HelideckSummaryForm;

const initialData: models.HelideckSummaryOverview =
	dummyData.getDefaultHelideckSummary();
